 /**
  * =============================================================================
  * account.js
  * =============================================================================
  * Account page functionality
  * =============================================================================
  */

var Account = {
  /**
   * Initialisation
   */
  init: function() {
  },

  onReady: function() {
    const reorder = document.querySelectorAll(".reorder-button");
    const addressDelete = document.querySelectorAll(".address-delete");

    reorder.forEach(function(element) {
      element.addEventListener("click", e => {
        let orderId = parseInt(e.target.getAttribute("data-orderindex"), 10);
        let order = orders[orderId];
        MP.Extensions.Cart.add(order);
      });
    });

    // A Dirty hack for the address delete button
    addressDelete.forEach(function(element) {
      element.addEventListener("click", e => {
        let formId = e.target.getAttribute("data-form-id");
        Shopify.postLink('/account/addresses/' + formId, { parameters: { _method: 'delete' } });
      });
    });

    function waitForElementToExist(selector) {
      return new Promise(resolve => {
        const existing = document.querySelector(selector);
        if (existing) {
          return resolve(existing);
        }

        const observer = new MutationObserver(() => {
          const found = document.querySelector(selector);
          if (found) {
            resolve(found);
            observer.disconnect();
          }
        });

        observer.observe(document.body, {
          subtree: true,
          childList: true,
        });
      });
    }

    /**
     * Polls until the points balance element shows a non-negative integer or timeout.
     * @param {number} timeoutMs
     * @param {number} intervalMs
     */
    function waitForPointsBalance(timeoutMs = 5000, intervalMs = 50) {
      return new Promise((resolve) => {
        function check() {
          waitForPointsBalanceElement(function existsCallback(exists) {
            if (exists) {
              weCanSetProgressBar();
              resolve();
            } else {
              setTimeout(check, intervalMs);
            }
          });
        }
        check();
      });
    }

    // Wait for the balance container, then kick off the async logic
    waitForElementToExist('.sweettooth-points-balance')
      .then(() => asyncCall())
      .catch(err => {
        console.warn("Failed waiting for .sweettooth-points-balance:", err);
      });

    async function asyncCall() {
      try {
        await waitForPointsBalance(20); // keeps polling forever until it succeeds
      } catch (err) {
        // This catch is just defensive; with the above version it won't reject.
        console.warn("Unexpected error in asyncCall:", err);
      }
    }

    function waitForPointsBalanceElement(checkifExists) {
      const elem = document.querySelector(".sweettooth-points-balance");
      if (!elem) {
        return checkifExists(false);
      }

      let points = elem.innerHTML.trim();
      points = parseInt(points, 10);

      if (!isNaN(points) && points >= 0) {
        checkifExists(true);
      } else {
        checkifExists(false);
      }
    }

    function weCanSetProgressBar() {
      const pointsBalanceElem = document.querySelector(".sweettooth-points-balance");
      if (!pointsBalanceElem) return;

      const points_balance_raw = pointsBalanceElem.innerHTML.trim();
      const points_balance = parseInt(points_balance_raw, 10);
      const free_shipping_threshold = free_shipping_threshold_setting;
      const points_increment = points_increment_setting;

      // Load reward tiers from script tag
      const rewardTiersScript = document.getElementById('reward-tiers-data');
      let rewardTiers = [];

      if (rewardTiersScript) {
        try {
          rewardTiers = JSON.parse(rewardTiersScript.textContent);
        } catch (e) {
          console.error("Invalid reward tiers", e);
        }
      }

      let points_breakdown_last = 0;
      let pointsAwayFrom = 0;
      let percentage = 0;
      let currentReward = null;

      // DOM elements
      const barWidth = document.querySelector(".progress-bar");
      const rewardInfo = document.querySelector(".reward-tier-info");
      const buttonRedeemPoints = document.querySelector(".redeem-points");
      const freeShippingBlock = document.querySelector(".free-shipping");
      const hasFreeShippingBlock = document.querySelector(".has-free-shipping");
      const placeholderContainer = document.querySelector(".placeholder-content");
      const realContentContainer = document.querySelector(".loyalty-real-content");
      const loyaltyPointsLoaded = document.querySelector(".loyalty-points");
      const loyaltyPointsPlaceholder = document.querySelector(".placeholder-loyalty-points");

      if (loyaltyPointsLoaded) {
        loyaltyPointsLoaded.classList.remove("opacity-0");
      }
      if (loyaltyPointsPlaceholder) {
        loyaltyPointsPlaceholder.classList.add("visually-hidden", "opacity-0");
      }

      // Reset reward info
      if (rewardInfo) {
        rewardInfo.classList.add("visually-hidden", "opacity-0");
        rewardInfo.innerHTML = "";
      }

      // CASE 1: Below free shipping threshold
      if (points_balance < free_shipping_threshold) {
        points_breakdown_last = free_shipping_threshold;
        pointsAwayFrom = free_shipping_threshold - points_balance;
        percentage = (points_balance / free_shipping_threshold) * 100;

        if (freeShippingBlock) {
          freeShippingBlock.classList.remove("visually-hidden", "opacity-0");
          const ptsElem = freeShippingBlock.querySelector(".points-away-free-shipping");
          if (ptsElem) ptsElem.innerHTML = pointsAwayFrom;
        }

      // CASE 2: Free shipping earned, but not yet voucher
      } else if (points_balance >= free_shipping_threshold && points_balance < points_increment) {
        const progressInRange = points_balance - free_shipping_threshold;
        const totalRange = points_increment - free_shipping_threshold;
        percentage = (progressInRange / totalRange) * 100;

        if (freeShippingBlock) freeShippingBlock.classList.add("d-none");

        if (rewardInfo) {
          rewardInfo.innerHTML = `You’ve unlocked <strong>free shipping</strong>! Earn <strong>${points_increment - points_balance} more points</strong> to get your first voucher.`;
          rewardInfo.classList.remove("visually-hidden", "opacity-0");
        }

      // CASE 3: Voucher tier earned
      } else {
        const currentTierStart = Math.floor(points_balance / points_increment) * points_increment;
        points_breakdown_last = currentTierStart + points_increment;
        pointsAwayFrom = points_breakdown_last - points_balance;
        percentage = ((points_balance - currentTierStart) / points_increment) * 100;

        if (freeShippingBlock) freeShippingBlock.classList.add("d-none");

        if (hasFreeShippingBlock) {
          hasFreeShippingBlock.classList.remove("visually-hidden", "opacity-0");

          waitForElementToExist(".points-away").then(el => {
            el.innerHTML = pointsAwayFrom;
          }).catch(() => {
            console.warn("⚠️ .points-away not found after waiting.");
          });
        }

        for (let tier of rewardTiers) {
          if (points_balance >= tier.min && points_balance <= tier.max) {
            currentReward = tier;
            break;
          }
        }

        if (currentReward && rewardInfo) {
          rewardInfo.innerHTML = `You're eligible for <strong>${currentReward.reward}</strong>! <em>(${currentReward.condition})</em>`;
          rewardInfo.classList.remove("visually-hidden", "opacity-0");
        }

        if (points_balance >= points_increment && buttonRedeemPoints) {
          buttonRedeemPoints.classList.remove("visually-hidden");
        }
      }

      // Update progress bar
      if (barWidth) {
        barWidth.style.width = `${percentage}%`;
      }

      // Reveal real content, hide placeholder
      if (placeholderContainer) {
        placeholderContainer.classList.add("visually-hidden", "opacity-0");
      }
      if (realContentContainer) {
        realContentContainer.classList.remove("visually-hidden", "opacity-0");
      }

      // Optional: log formatted milestone
      const formattedMilestone = (points_breakdown_last / 100).toLocaleString('en-UK', {
        style: 'currency',
        currency: 'GBP',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      console.log(`Next milestone: ${formattedMilestone}`);
    }
  },

  /**
   * Add the bundle cart attribute
   * @param {Event} e 
   */
  handleOrderToCart: function(e) {
    const config = MP.Utilities.fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';

    const fetchPromise = fetch(`${routes.cart_update_url}`, config).then(response => response.json());

    return fetchPromise;
  },

  updatePointsAwayText: function(points_balance) {
    // NOTE: This currently references variables (rewardTiers, currentReward, rewardInfo, pointsAwayFrom,
    // buttonRedeemPoints, points_increment) that are out of scope here. To make this work properly you’d need
    // to refactor so shared state/DOM references are passed in or stored on the Account object.
    console.warn("updatePointsAwayText is not fully implemented; refactor needed for shared scope.");
  }
}

export default Account;
